import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

export default function WaitlistForm() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [waitlistCount, setWaitlistCount] = useState(0);
  const [countLoading, setCountLoading] = useState(true);

  useEffect(() => {
    fetchWaitlistCount();
  }, []);

  const fetchWaitlistCount = async () => {
    try {
      const { count, error } = await supabase
        .from('waitlist')
        .select('*', { count: 'exact', head: true });

      if (!error) {
        setWaitlistCount(count || 0);
      }
    } catch (countError) {
      console.error('Error fetching waitlist count:', countError);
    } finally {
      setCountLoading(false);
    }
  };

  const generateRandomPassword = () => {
    return Math.random().toString(36).slice(-8) + Math.random().toString(36).slice(-8) + '!A1';
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const { data: existingUser } = await supabase
        .from('waitlist')
        .select('email')
        .eq('email', email)
        .maybeSingle();

      if (existingUser) {
        setMessage('You\'re already on the waitlist. We\'ll email you when access opens up.');
        setMessageType('success');
        setEmail('');
        fetchWaitlistCount();
        return;
      }

      const { error } = await supabase.auth.signUp({
        email,
        password: generateRandomPassword(),
        options: {
          emailRedirectTo: `${window.location.origin}/waitlist`,
          data: { waitlist_signup: true }
        }
      });

      if (error && !error.message.includes('already registered')) {
        throw error;
      }

      setMessage('You\'re in. Check your email to confirm your address.');
      setMessageType('success');
      setEmail('');
      fetchWaitlistCount();
    } catch (submitError) {
      console.error('Error joining waitlist:', submitError);
      setMessage('Couldn\'t join the waitlist. Please try again.');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="waitlist-form-wrap">
      <form id="waitlist-form" onSubmit={handleSubmit} className="waitlist-form">
        <input
          type="email"
          id="email"
          name="email"
          placeholder="Email address"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          required
          disabled={loading}
          className="input-field"
        />
        <button type="submit" disabled={loading} className="btn-primary">
          {loading ? 'Joining...' : 'Join waitlist'}
        </button>
      </form>

      <p className="waitlist-count">
        {countLoading ? 'Loading waitlist...' : `${waitlistCount} people already joined`}
      </p>

      {message && (
        <p className={messageType === 'error' ? 'waitlist-message error' : 'waitlist-message success'}>
          {message}
        </p>
      )}
    </div>
  );
}
